<template>
  <div class="user-page full-height">
    <tableCon>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/container' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>FBA装箱单管理</el-breadcrumb-item>
          <el-breadcrumb-item>FBA装箱单列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <div class="query-title">装箱批次号:</div>
            <div class="flex1">
              <el-input placeholder="请输入内容" clearable v-model="queryInfo.containerBatchNo" size="small"
                @keyup.enter.native="searchList">
              </el-input>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">客户ID:</div>
            <div class="flex1">
              <el-input placeholder="请输入内容" clearable v-model="queryInfo.userName" size="small"
                @keyup.enter.native="searchList">
              </el-input>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">客户姓名:</div>
            <div class="flex1">
              <el-input placeholder="请输入内容" clearable v-model="queryInfo.realName" size="small"
                @keyup.enter.native="searchList">
              </el-input>
            </div>
          </el-col>
          <!-- <el-col :span="6" class="display-row">
            <div class="query-title">状态:</div>
            <div class="flex1">

              <el-select v-model="queryInfo.containerState"
                         placeholder="请选择"
                         size="small" clearable>
                <el-option
                    v-for="item in containerStateList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-col> -->
          <el-col :span="6" class="display-row">
            <div class="query-title">发送地区:</div>
            <div class="flex1">
              <el-input placeholder="请输入内容" clearable v-model="queryInfo.sendArea" size="small"
                @keyup.enter.native="searchList">
              </el-input>
            </div>
          </el-col>
        </el-row>
        <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <div class="query-title">物流公司:</div>
            <div class="flex1">

              <el-select v-model="queryInfo.logisticsCompanyId" placeholder="请选择" size="small" clearable>
                <el-option v-for="item in dropDownList" :key="item.id" :label="item.companyName" :value="item.id">
                </el-option>

              </el-select>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">国际运单号:</div>
            <div class="flex1">
              <el-input placeholder="请输入内容" clearable v-model="queryInfo.waybillNumber" size="small"
                @keyup.enter.native="searchList">
              </el-input>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">线路:</div>
            <div class="flex1">
              <el-select v-model="queryInfo.route" placeholder="请选择" size="small" clearable>
                <el-option v-for="item in routeList" :key="item.value" :label="item.label" :value="item.label">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">创建开始日:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.createTimeStart" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
        </el-row>
        <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <div class="query-title">创建结束日:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.createTimeEnd" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">发送开始日:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.sendTimeStart" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">发送结束日:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.sendTimeEnd" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
        </el-row>
        <el-row class="search-row">
          <el-col :span="18" class="display-row">
            <div class="search-btn-container search-btn-container-status">
              <el-button class="search-btn btn-blue" :class="{ lxBtnBlueLight: curIndex === '' }"
                @click="changeTab('')">全部
              </el-button>
              <el-button class="search-btn btn-blue" :class="{ lxBtnBlueLight: curIndex === 6 }"
                @click="changeTab(6)">待装箱<span class="lx-red">({{ containerCount.waitBoxCount }})</span></el-button>
              <el-button class="search-btn btn-blue" :class="{ lxBtnBlueLight: curIndex === 0 }"
                @click="changeTab(0)">装箱中<span class="lx-red">({{ containerCount.boxCount }})</span></el-button>
              <el-button class="search-btn btn-blue" :class="{ lxBtnBlueLight: curIndex === 7 }"
                @click="changeTab(7)">装箱完<span class="lx-red">({{ containerCount.finishBoxNum }})</span></el-button>
              <el-button class="search-btn btn-blue" :class="{ lxBtnBlueLight: curIndex === 1 }"
                @click="changeTab(1)">待支付<span class="lx-red">({{ containerCount.waitPayCount }})</span></el-button>
              <el-button class="search-btn btn-blue" :class="{ lxBtnBlueLight: curIndex === 2 }"
                @click="changeTab(2)">待传发票<span class="lx-red">({{ containerCount.invoicePendingCount
                }})</span></el-button>
              <el-button class="search-btn btn-blue" :class="{ lxBtnBlueLight: curIndex === 3 }"
                @click="changeTab(3)">待发送<span class="lx-red">({{ containerCount.waitSendCount }})</span></el-button>
              <el-button class="search-btn btn-blue" :class="{ lxBtnBlueLight: curIndex === 4 }"
                @click="changeTab(4)">已发送<span class="lx-red"></span></el-button>
              <el-button class="search-btn btn-blue" :class="{ lxBtnBlueLight: curIndex === 5 }"
                @click="changeTab(5)">已取消<span class="lx-red"></span></el-button>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="search-btn-container" style="text-align:right">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchList()">搜索</el-button>
              <el-button class="search-btn btn-blue" @click="toSort">排序</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 内容 -->
      <div slot="table" class="full-height display-col">
        <el-table :data="containerList" :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle"
          v-loading="isLoading" border stripe style="width: 100%" height="550">
          <el-table-column type="index" align="center" label="序号" width="40"></el-table-column>
          <el-table-column :show-overflow-tooltip="item.key === 'comments'" v-for="(item, index) in asyncColumns"
            :key="index" align="center" :label="item.name" :prop="item.key" :width="item.width ? item.width : 'auto'"
            :min-width="item.minWidth ? item.minWidth : 'auto'">
            <template v-slot="scope">
              <!-- 订单操作 -->
              <div v-if="item.key === 'handle'" style="display: inline-block" class="btn-row">
                <el-button class="list-btn-four btn-blue" v-if="scope.row.containerState != 5"
                  @click="toContainerDetail(scope.row)">
                  装箱详情
                </el-button>
                <el-button class="list-btn-four btn-deepblue" v-if="scope.row.containerState != 5"
                  @click="ModifyContainer(scope.row)">编辑
                </el-button>
                <el-button class="list-btn-four btn-red"
                  v-if="scope.row.containerState == 0 || scope.row.containerState == 7"
                  @click="addSendBill(scope.row)">发送账单
                </el-button>
                <el-button class="list-btn-four  btn-blue"
                  v-if="scope.row.containerState != 0 && scope.row.containerState != 5 && scope.row.containerState != 6 && scope.row.containerState != 7"
                  @click="addBill(scope.row)">账单
                </el-button>
                <el-button class="list-btn-four  btn-red" v-if="scope.row.containerState == 6"
                  @click="cannelBill(scope.row)">取消
                </el-button>
                <el-button class="list-btn-four  btn-deepblue"
                  @click="ContainerOrderList(scope.row.containerBatchNo, scope.row.customerId, scope.row.id, scope.row.containerState)">
                  装箱单
                </el-button>
                <el-button class="list-btn-four  btn-deepblue"
                  v-if="scope.row.containerState == 1 || scope.row.containerState == 2 || scope.row.containerState == 3"
                  @click="invoiceExport(scope.row.id)">导出发票
                </el-button>
              </div>
              <!-- 发票 -->
              <div v-else-if="item.key === 'invoiceUrl'">
                <el-upload action="/"
                  :http-request="(file) => uploadVideo(scope.row.containerBatchNo, scope.row.containerState, file)"
                  accept=".pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" :limit='1'
                  :show-file-list='false'>
                  <el-button class="list-btn btn-blue" ref='uploadVideo'>上传
                  </el-button>
                </el-upload>
                <a class="link" @click="downloadFile(scope.row)">{{ scope.row.invoiceUrl }}</a>
                <el-button v-if="scope.row.containerState == 2" class="list-btn btn-blue" @click="noInvoice(scope.row)"
                  ref='uploadVideo'>无需发票 </el-button>
              </div>
              <!-- 创建日期 -->
              <div v-else-if="item.key === 'createTime'">
                {{ scope.row.createTime | formatDateFilter }}
              </div>
              <!-- 状态 -->
              <div v-else-if="item.key === 'containerState'">
                <div v-for="(item, i) in containerStateList" :key="i">
                  <div v-if="scope.row.containerState == item.value">
                    {{ item.label }}
                  </div>
                </div>
              </div>
              <!-- 发送日 -->
              <div v-else-if="item.key === 'sendTime'">
                {{ scope.row.sendTime | formatDateFilter }}
              </div>
              <!-- 物流信息 -->
              <div v-else-if="item.key === 'logisticeCompany'">
                <div class="overflowDot" :title="scope.row.logisticeCompany">{{ scope.row.logisticeCompany }}</div>
                <div>{{ scope.row.waybillNumber }}</div>
                <div class="overflowDot" :title="scope.row.logisticeState">{{ scope.row.logisticeState }}</div>
              </div>
              <!-- 收件信息 -->
              <div v-else-if="item.key === 'recipientName'">
                <!-- <div class="overflowDot" :title="scope.row.logisticeCompany">{{scope.row.logisticeCompany}}</div> -->
                <!-- <div>{{scope.row.recipientName}}</div>
                <div>{{scope.row.zipCode}}</div>
                <div>{{scope.row.deliveryAddress}}</div> -->
                <div>
                  <span>收件人：</span>
                  <span>{{ scope.row.recipientName }}</span>
                </div>
                <div>
                  <span>收件人邮编：</span>
                  <span>{{ scope.row.zipCode }}</span>
                </div>
                <div>
                  <span>收件地址：</span>
                  <span>{{ scope.row.deliveryAddress }}</span>
                </div>
                <!-- <div class="overflowDot" :title="scope.row.logisticeState">{{scope.row.logisticeState}}</div> -->
              </div>
              <div v-else-if="item.key === 'route'">
                {{ scope.row.route === '1' ? "空运" : "海运" }}
              </div>
              <!-- 进口商信息 -->
              <div v-else-if="item.key === 'senderAddress'">
                <!-- <div class="overflowDot" :title="scope.row.logisticeCompany">{{scope.row.logisticeCompany}}</div> -->
                <!-- <div>{{scope.row.recipientName}}</div>
                <div>{{scope.row.zipCode}}</div>
                <div>{{scope.row.deliveryAddress}}</div> -->
                <div>
                  <span>进口商：</span>
                  <span>{{ scope.row.senderName }}</span>
                </div>
                <div>
                  <span>进口商邮编：</span>
                  <span>{{ scope.row.senderZipCode }}</span>
                </div>
                <div>
                  <span>进口商地址：</span>
                  <span>{{ scope.row.senderAddress }}</span>
                </div>
                <!-- <div class="overflowDot" :title="scope.row.logisticeState">{{scope.row.logisticeState}}</div> -->
              </div>
              <div v-else-if="item.key === 'storeName'">
                <div>
                  <span>商铺名称：</span>
                  <span>{{ scope.row.storeName }}</span>
                </div>
                <div>
                  <span>商铺地址：</span>
                  <span>{{ scope.row.storeAddress }}</span>
                </div>
              </div>
              <div v-else-if="item.key === 'comments'">
                <span>{{ scope.row.comments }}</span>
              </div>
              <!-- 其他不需要处理的 -->
              <span v-else>
                {{ scope.row[item.key] }}
              </span>
            </template>
          </el-table-column>

        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNum" :page-sizes="[5, 10, 20, 50, 100, 200]" :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </tableCon>
    <!-- 装箱单编辑弹框 -->
    <el-dialog :visible.sync="ContainerOrderListVisible" width="70%" title="编辑装箱单" @close="splitDialogClosed">
      <el-table :data="containerOrderList" :header-cell-style="tableStyle.headerStyle" border stripe style="width: 100%">
        <el-table-column type="index" align="center" label="序号" width="40"></el-table-column>
        <el-table-column prop="orderNo" align="center" label="订单编号" width="70"></el-table-column>
        <el-table-column prop="configLocatorName" align="center" label="库位" width="90"></el-table-column>
        <el-table-column prop="goodsName" label="商品名" min-width="200"></el-table-column>
        <el-table-column label="参数" width="90">
          <template slot-scope="scope">
            <span>{{scope.row.colour}}</span>
            <span v-if="scope.row.colour && scope.row.goodsSize">-</span>
            <span>{{scope.row.goodsSize}}</span>
          </template>
        </el-table-column>
        <el-table-column label="图片" align="center" width="115">
          <template slot-scope="scope">
            <img @click="imgclick(scope.row.pictureUrl, true)"
              v-if="scope.row.pictureUrl && scope.row.pictureUrl.length > 0" :src="scope.row.pictureUrl" alt=""
              class="list-image" style="width: 100px;height: 100px;">
            <img v-else src="../../assets/images/default.png" alt="" class="list-image"
              style="width: 100px;height: 100px;">
            <!--<img :src="scope.row.badPicture1" alt="" style="width: 100px;height: 100px;">-->
          </template>
        </el-table-column>
        <el-table-column prop="goodsCount" align="center" label="商品数量" width="120"></el-table-column>
        <template v-if="curContainerState == 0 || curContainerState == 6 || curContainerState == 7">
          <el-table-column align="center" label="申请数量" min-width="130">
            <template slot="header">
              <span style="color: #3e8ef7;font-weight: bold;">申请数量</span>
            </template>
            <template v-slot="scope">
              <el-input-number clearable v-model="scope.row.containerGoodsCount" :max="scope.row.maxCount" :min="1"
                               size="small" style="width: 100px">
              </el-input-number>
            </template>
          </el-table-column>
        </template>
        <el-table-column prop="canApplyCount" align="center" label="可装箱数量" width="90"></el-table-column>
        <el-table-column prop="sentSize" label="实际发货数量" width="100" align="center"></el-table-column>
        <el-table-column prop="orderType" label="FBA/乐天/第三方/无在库" width="90">
          <template slot-scope="scope">
            <div>{{ scope.row.orderType | isFBA }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="fnsku" label="编号" width="90"></el-table-column>
        <el-table-column prop="goodsNameCus" label="品名" min-width="200">
          <template v-slot="scope">
            <el-input type="textarea" placeholder="" v-model="scope.row.goodsNameCus" size="small" disabled>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column prop="orderStatus" align="center" label="订单状态" width="90">
          <template v-slot="scope">
            <div v-for="(item, i) in orderStatusOptions" :key="i">
              <div v-if="scope.row.orderStatus == item.value">
                {{ item.label }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="categoryFlag" align="center" label="仓库保管" width="90">
          <template slot-scope="scope">
            <div>{{ scope.row.categoryFlag == 0 ? "否" : "是" }}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="refundCount" align="center" label="退货数量" width="90"></el-table-column>
        <el-table-column prop="destroyCount" align="center" label="销毁数量" width="90"></el-table-column> -->
        <el-table-column prop="bindingNo" align="center" label="同捆" width="90"></el-table-column>
        <!--<el-table-column prop="totalNetWeight" align="center" label="净重" width="90"></el-table-column>-->
        <el-table-column prop="refundCount" align="center" label="退货数量" width="90"></el-table-column>
        <el-table-column prop="destroyCount" align="center" label="销毁数量" width="90"></el-table-column>
        <el-table-column prop="totalNetWeight" align="center" label="净重" width="90">
          <template v-slot="scope">
            <div>
              {{ scope.row.totalNetWeight.toFixed(2) }}
            </div>
          </template>
        </el-table-column>
        <template v-if="curContainerState == 0 || curContainerState == 6 || curContainerState == 7">
          <!--<el-table-column align="center" label="申请数量" min-width="130">
            <template v-slot="scope">
              <el-input-number clearable v-model="scope.row.containerGoodsCount" :max="scope.row.maxCount" :min="1"
                size="small" style="width: 100px">
              </el-input-number>
            </template>
          </el-table-column>-->
          <el-table-column align="center" label="删除" width="90">
            <template v-slot="scope">
              <div class="btn-row">
                <el-button type="primary" plain @click="delGooods(scope.row)" size="mini">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </template>
      </el-table>
      <!-- </div>  -->
      <span slot="footer" class="dialog-footer">
        <template v-if="curContainerState == 0 || curContainerState == 6 || curContainerState == 7">
          <el-button class="form-btn btn-green" @click="isVisiable = true">新增商品</el-button>
          <el-button class="form-btn btn-blue" @click="onSave()">保存</el-button>
        </template>
        <el-button class="form-btn btn-blue" style="margin-right:15px" @click="handleExport">导出</el-button>
        <el-button class="form-btn btn-gray" @click="ContainerOrderListVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!--    图片放大-->
    <el-dialog title="" :visible.sync="visible" width="30%" show-close center>
      <img width="100%" height="auto" :src="imgurl" alt="" class="list-image">
      <!--    <img :src="this.$store.state.imgurl" alt="">-->
    </el-dialog>
    <lx-sort :visible.sync="isVisibleSort" :list="columns" @confirm="doSaveColumns"></lx-sort>

    <!-- 修改页面 -->
    <el-dialog :visible.sync="ModifyPageVisible" width="61%" title="修改装箱单" @close="ModifyPageClosed">
      <el-form :model="ModifyContainerOrderInfo" :rules="rules" ref="dialogForm" class="demo-userInfo">
        <el-form-item label="装箱批次号:" label-width="120px">
          <!-- <div class="query-title" style="width: 250px">装箱批次号:{{ModifyContainerOrderInfo.containerBatchNo}}</div> -->
          <el-input v-model="ModifyContainerOrderInfo.containerBatchNo" style="width: 200px" size="small"
            disabled></el-input>
        </el-form-item>
        <el-row class="search-row" style="width: 1500px">
          <el-col :span="7" class="display-row">
            <el-form-item label="进口商:" prop="senderName" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.senderName" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" class="display-row">
            <el-form-item label="进口商电话：" prop="senderPhone" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.senderPhone" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="search-row" style="width: 1500px">
          <el-col :span="7" class="display-row">
            <el-form-item label="进口商地区：" prop="addresserArea" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.addresserArea" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" class="display-row">
            <el-form-item label="进口商地址：" prop="senderAddress" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.senderAddress" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="search-row" style="width: 1500px">
          <el-col :span="7" class="display-row">
            <el-form-item label="进口商邮编：" prop="senderZipCode" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.senderZipCode" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" class="display-row">
            <el-form-item label="进口商Email：" prop="senderEmail" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.senderEmail" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="search-row" style="width: 1500px">
          <el-col :span="7" class="display-row">
            <el-form-item label="法人编号：" prop="senderLegalNo" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.senderLegalNo" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" class="display-row">
            <el-form-item label="Naccs账户：" prop="senderNaccsAccount" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.senderNaccsAccount" style="width: 200px"
                size="small"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="search-row" style="width: 1500px">
          <el-col :span="7" class="display-row">
            <el-form-item label="公司名称：" prop="senderCompanyName" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.senderCompanyName" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" class="display-row">
          </el-col>
        </el-row>
        <el-row class="search-row" style="width: 1500px">
          <el-col :span="7" class="display-row">
            <el-form-item label="收件人：" prop="recipientName" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.recipientName" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" class="display-row">
            <el-form-item label="收件人电话：" prop="deliveryPhone" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.deliveryPhone" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="search-row" style="width: 1500px">
          <el-col :span="7" class="display-row">
            <el-form-item label="收件地区：" prop="sendArea" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.sendArea" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" class="display-row">
            <el-form-item label="收件地址：" prop="deliveryAddress" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.deliveryAddress" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="search-row" style="width: 1500px">
          <el-col :span="7" class="display-row">
            <el-form-item label="收件人邮编：" prop="zipCode" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.zipCode" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" class="display-row">
          </el-col>
        </el-row>
        <!-- <el-row class="search-row" style="width: 1500px">
          <el-col :span="7" class="display-row">
            <el-form-item label="EMAIL：" prop="emailAddress" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.emailAddress" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" class="display-row">
            <el-form-item label="进口商编码：" prop="importCode " label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.importCode" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row class="search-row" style="width: 1500px">
          <el-col :span="7" class="display-row">
            <el-form-item label="线路：" prop="route" label-width="120px">
              <el-select v-model="ModifyContainerOrderInfo.route" placeholder="请选择" size="small" clearable
                @change='routeChange'>
                <el-option v-for="item in routeList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>

            </el-form-item>
          </el-col>
          <el-col :span="7" class="display-row">
            <el-form-item label="物流公司：" prop="logisticsCompanyId" label-width="120px">

              <el-select v-model="ModifyContainerOrderInfo.logisticsCompanyId" placeholder="请选择" size="small" clearable>
                <el-option v-for="item in dropDownListEdit" :key="item.id" :label="item.companyName" :value="item.id">
                </el-option>
              </el-select>

            </el-form-item>
          </el-col>
          <!--  <el-col :span="7" class="display-row">
            <el-form-item label="发送地区：" prop="sendArea" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.sendArea" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row class="search-row" style="width: 1500px">
          <el-col :span="7" class="display-row">
            <el-form-item label="运单号：" prop="waybillNumber" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.waybillNumber" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="search-row" style="width: 1500px">
          <el-col :span="7" class="display-row">
            <el-form-item label="备注：" prop="comments" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.comments" style="width: 650px;"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="ModifyPageVisible = false">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="replySave" type="primary">提 交</el-button>
      </span>

      <!-- </div>  -->

    </el-dialog>
    <lx-sort :visible.sync="isVisibleSort" :list="columns" @confirm="doSaveColumns"></lx-sort>

    <SelectGoods :isVisiable.sync="isVisiable" :selectedList="containerOrderList" :userId="curUserId"
      @confirm="onConfirm">
    </SelectGoods>
  </div>
</template>

<script>
import { columns as originColumns } from "./containerColumns";
import { filterList } from "@/assets/js/utils";
import LxSort from "@/components/LxSort/index";
import tableCon from "../../views/tableContainer";
import SelectGoods from "./cmp/SelectGoods";

export default {
  name: 'container',
  components: {
    LxSort,
    tableCon,
    SelectGoods
  },
  data () {

    // 自定义邮箱校验规则
    var checkEmail = (rule, value, cb) => {
      const regEail = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
      if (regEail.test(value)) {
        return cb();
      }
      cb(new Error("请输入合法的邮箱"));
    };
    // 自定义手机号校验规则
    var checkMobile = (rule, value, cb) => {
      const regMobile = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (regMobile.test(value)) {
        return cb();
      }
      cb(new Error("请输入合法的手机号"));
    };
    return {
      currentdate: '',
      curIndex: '', // 默认选中第0个
      isLoading: true,
      visible: false,
      isVisibleSort: false,
      originColumns, // 初始表头
      columns: [], // 处理后的 全部的表头
      asyncColumns: [], // 接口返回的已选择表头
      orderList: [],
      menuSettingData: {
        menuId: 'staffContainer'
      },
      rules: {
        senderName: [
          { required: true, message: '进口商不能为空', trigger: 'blur' }
        ],
        senderAddress: [
          { required: true, message: '进口商地址不能为空', trigger: 'blur' }
        ],
        senderPhone: [{ required: true, message: "进口商电话不能为空", trigger: "blur" }
        ],
        senderZipCode: [
          { required: true, message: '进口商邮编不能为空', trigger: 'blur' }
        ],
        senderEmail: [
          { required: true, message: '进口商Email不能为空', trigger: 'blur' }
        ],
        recipientName: [
          { required: true, message: '收件人不能为空', trigger: 'blur' }
        ],
        deliveryAddress: [
          { required: true, message: '收件地址不能为空', trigger: 'blur' }
        ],
        deliveryPhone: [{ required: true, message: "收件人电话不能为空", trigger: "blur" }
        ],
        zipCode: [
          { required: true, message: '收件人邮编不能为空', trigger: 'blur' }
        ],
        /* emailAddress: [
          {required: true, message: 'EMAIL不能为空', trigger: 'blur'},
          {validator: checkEmail}
        ], */
        route: [
          { required: true, message: '线路不能为空', trigger: 'blur' }
        ],
        sendArea: [
          { required: true, message: '收件地区不能为空', trigger: 'blur' }
        ],
        addresserArea: [
          { required: true, message: '进口商地区不能为空', trigger: 'blur' }
        ],
        logisticeCompany: [
          { required: true, message: '物流编号不能为空', trigger: 'blur' }
        ],
        logisticsCompanyId: [
          { required: true, message: '物流编号不能为空', trigger: 'blur' }
        ],
        /* waybillNumber: [
          {required: true, message: '运单号不能为空', trigger: 'blur'}
        ], */
      },
      imgurl: '',
      //上传发票时附带的额外参数
      imgDataObj: {
        policy: '',
        signature: '',
        key: '',
        ossaccessKeyId: '',
        dir: '',
        host: '',
        timeStamp: ''
      },
      queryInfo: {
        containerBatchNo: '',
        userName: '',
        realName: '',
        containerState: '',
        sendArea: '',
        createTimeStart: '',
        createTimeEnd: '',
        sendTimeStart: '',
        sendTimeEnd: '',
        logisticsCompanyId: '',
        logisticeCompany: '',
        waybillNumber: '',
        route: '',
        pageSize: 10,
        pageNum: 1,
      },
      //修改装箱单实体类
      ModifyContainerOrderInfo: {
        containerBatchNo: '',
        recipientName: '',
        deliveryAddress: '',
        deliveryPhone: '',
        zipCode: '',
        senderName: '',
        senderAddress: '',
        senderPhone: '',
        senderZipCode: '',
        senderEmail: '',
        emailAddress: '',
        importCode: '',
        route: '',
        sendArea: '',
        addresserArea: '',
        logisticeCompany: '',
        logisticsCompanyId: '',
        waybillNumber: '',
        comments: ''
      },
      // orderDateRangeValue:[],
      shipDateRangeValue: [],
      containerStateList: [
        {
          value: '0',
          label: '装箱中'
        }, {
          value: '1',
          label: '待支付'
        }, {
          value: '2',
          label: '待传发票'
        }, {
          value: '3',
          label: '待发送'
        }, {
          value: '4',
          label: '已发送'
        }, {
          value: '5',
          label: '已取消'
        }, {
          value: '6',
          label: '待装箱'
        }, {
          value: '7',
          label: '装箱完'
        }
      ],
      routeList: [
        {
          value: '1',
          label: '空运'
        },
        {
          value: '2',
          label: '海运'
        }
      ],
      containerCount: {
        total: 0,
        waitBoxCount: 0,
        boxCount: 0,
        finishBoxNum: 0,
        waitPayCount: 0,
        invoicePendingCount: 0,
        waitSendCount: 0,
        sendCount: 0,
        cancelCount: 0
      },
      aliyunOssToken: {},
      //物流公司的下拉地址
      dropDownList: [],
      dropDownListEdit: [],
      //上传文件
      curRowPDF: 0,
      updataNo: "",
      orderStatusOptions: [],
      containerList: [],
      ContainerOrderListVisible: false,
      // 修改页面展示标准
      ModifyPageVisible: false,
      ContainerInfo: "",
      containerOrderList: [],
      splitOrderInfo: {},
      splitForm: {},
      total: 0,
      isVisiable: false, // 选择商品弹框
      curUserId: null,
      curId: null,
      SelectedGoodsList: [], // 当前已选择的商品
      curContainerState: null, // 当前编辑装箱单的状态
    };
  },
  created () {
    this.queryInfo.containerBatchNo = this.$route.query.containerBatchNo;
    this.orderStatusOptions = [
      {
        value: '0',
        label: '等待到库'
      },
      {
        value: "1",
        label: '待购买',
      },
      {
        value: "2",
        label: '购买完',
      },
      {
        value: '4',
        label: '到库'
      },
      {
        value: '8',
        label: '检品中'
      },
      {
        value: '12',
        label: '检品完'
      },
      {
        value: '16',
        label: '仓库保管中'
      },
      {
        value: '20',
        label: '申请发货'
      },
      {
        value: '24',
        label: '不良待处理'
      },
      {
        value: '26',
        label: '不良驳回'
      },

      {
        value: '28',
        label: '换货待发回'
      },
      {
        value: '32',
        label: '换货等待到货'
      },
      {
        value: '36',
        label: '待部分退货'
      },
      {
        value: '40',
        label: '补发等待到货'
      },
      {
        value: '44',
        label: '待支付'
      },
      {
        value: '48',
        label: '待发送'
      },
      {
        value: '52',
        label: '已发送'
      },
      {
        value: '56',
        label: '已取消'
      },
      {
        value: '60',
        label: '退货申请中'
      },
      {
        value: '64',
        label: '退货待支付'
      },
      {
        value: '68',
        label: '待退货'
      },
      {
        value: '72',
        label: '已退货'
      },
      {
        value: '76',
        label: '销毁申请中'
      },
      {
        value: '80',
        label: '销毁待支付'
      },
      {
        value: '82',
        label: '待部分销毁'
      },
      {
        value: '84',
        label: '已销毁'
      },
      {
        value: '88',
        label: '检品完'
      },
      {
        value: '89',
        label: '无法购买'
      },
    ];
    this.getAsyncColumns().then(() => {
      this.getContainerCount();
      this.getContainerList();
      this.getDropDownList();
    });
  },
  // activated () {
  //   this.getAsyncColumns().then(() => {
  //     this.getContainerCount();
  //     this.getContainerList();
  //     this.getDropDownList();
  //   });
  // },
  methods: {
    changeTab (index) {
      this.curIndex = index
      this.searchList()
    },
    imgclick (url, visible) {
      this.visible = true
      this.imgurl = url
    },
    async noInvoice (row) {
      const { data: res } = await this.$http.post(`cmsContainer/skipInvoice`, {
        id: row.id,
      });
      if (res.code == 200) {
        this.$message.success('操作成功')
        this.getContainerCount();
        this.getContainerList();
      } else {
        this.$message.warning(res.message)
      }
    },
    handleExport () {
      let date = this.dateFormat(new Date())
      let data = {
        containerBatchNo: this.ContainerInfo
      }
      this.$http({
        url: "box/exportBoxDetail",
        method: 'post',
        data,
        responseType: 'blob', // 表明返回服务器返回的数据类型
        headers: {
          'Content-Type': 'application/json'
        },
      }).then((res) => {
        //创建一个隐藏的a连接，
        const link = document.createElement('a');
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none';
        //设置连接
        link.href = URL.createObjectURL(blob);
        link.download = `装箱申请P${date}.xlsx`;
        document.body.appendChild(link);
        //模拟点击事件
        link.click();
      }).catch(() => {
      })
    },
    dateFormat (time) {
      let date = new Date(time);
      let year = date.getFullYear();
      let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      // 拼接
      return year + '' + month + '' + day + '' + hours + '' + minutes;
    },
    // 获取已选择列
    getAsyncColumns () {
      return new Promise((resolve) => {
        // 接口start
        this.$http.get("menu/menuSetting", {
          params: {
            menuId: 'staffContainer'
          }
        }).then((res) => {
          var result = [];
          if (res.data.code === 200) {
            var record = res.data.data;
            this.menuSettingData = record;
            result = JSON.parse(record.menuSetting);
          }
          if (result && result.length > 0) {
            result.forEach((item) => {
              this.$set(item, "isShow", true);
            });
            let noSelectList = filterList(
              this.originColumns,
              result,
              "columnId"
            );
            this.columns = result.concat(noSelectList);
            this.asyncColumns = result;
            resolve();
          } else {
            this.columns = this.originColumns;
            this.columns.forEach((item) => {
              this.$set(item, "isShow", true);
            });
            this.asyncColumns = this.columns;
            resolve();
          }
        });
      });
    },
    // 保存选择的列
    doSaveColumns (list) {
      var my = this;
      // 接口
      let url = "menu/updateMenuSetting";
      this.menuSettingData.menuSetting = JSON.stringify(list);
      this.$http.post(url, this.menuSettingData).then(res => {
        if (res.data.code === 200) {
          this.isVisibleSort = false;
          my.$message({
            type: "success",
            message: "保存成功",
          });
          this.queryInfo.pageNum = 1;
          this.getAsyncColumns().then(() => {
            this.getContainerList();
          });
        } else {
          my.$message({
            type: "warning",
            message: "保存失败",
          });
        }
      })
    },
    // 排序
    toSort () {
      this.isVisibleSort = true;
    },
    indexMethod (index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    orderDateRange () {
    },
    shipDateRange () {
    },
    //拆单按钮显示
    showSplitOrderBtn (status) {
      // console.log(status);
      if (status == 0 || status == 4 || status == 8 || status == 12 || status == 16 || status == 48) {
        return true;
      } else {
        return false;
      }
    },
    queryInfoClear () {
      this.curIndex = '',
        this.queryInfo.containerBatchNo = '',
        this.queryInfo.userName = '',
        this.queryInfo.realName = '',
        this.queryInfo.containerState = '',
        this.queryInfo.sendArea = '',
        this.queryInfo.createTimeStart = '',
        this.queryInfo.createTimeEnd = '',
        this.queryInfo.waybillNumber = '',
        this.queryInfo.route = '',
        this.queryInfo.sendTimeStart = '',
        this.queryInfo.sendTimeEnd = '',
        this.queryInfo.logisticeCompany = '',
        this.queryInfo.logisticsCompanyId = '',
        this.queryInfo.pageSize = 10,
        this.queryInfo.pageNum = 1,
        // this.orderDateRangeValue = [];
        this.shipDateRangeValue = [];
    },

    searchList () {
      this.queryInfo.containerState = this.curIndex
      this.queryInfo.pageNum = 1;
      this.getContainerCount();
      this.getContainerList();
    },
    //保存修改装箱单
    replySave () {
      this.modifyContainerOrder()
    },
    //账单详情
    addBill (e) {
      this.$router.push({
        path: 'containerBillDetail',
        query: {
          id: e.id,
          isAdd: 0,
          containerBatchNo: e.containerBatchNo,
        }
      })
    },
    //发送账单
    async addSendBill (e) {
      const { data: res } = await this.$http.post("cmsContainer/clickBill", { "containerBatchNo": e.containerBatchNo });
      if (res.code == 200) {
        this.$router.push({
          path: 'containerBill',
          query: {
            containerBatchNo: e.containerBatchNo,
            isAdd: 1,
          }
        })
      } else {
        this.$message({
          type: 'warning',
          message: res.message
        })
      }
    },
    categoryFlagChanged (row) {
      //改变状态接口 params row.No,row.categoryFlag
      // console.log(row.categoryFlag);
      setTimeout(() => {
        row.categoryFlag = !row.categoryFlag;
        alert('failed')
      }, 1000);

    },
    beforeUploadVideo (index) {
      this.curRowPDF = index
    },
    //上传pdf
    uploadVideo (containerBatchNo, containerState, file) {
      let _self = this;
      const isPDF = file.file.type === 'application/pdf';
      const isEXCEL = file.file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      if (!isPDF && !isEXCEL) {
        _self.$message.error('上传文件只能是 PDF和excel 格式!');
        return
      }
      let formdata = new FormData();
      formdata.append('file', file.file)
      formdata.append('modular', 'FBAContainer')
      if (isPDF) {
        formdata.append('type', 'PDF')
      }
      if (isEXCEL) {
        formdata.append('type', 'EXCEL')
      }
      _self.$http.post('aliyun/oss/upload', formdata).then((res) => {
        if (res.data.code == 200) {
          const { data: res1 } = _self.$http.post("cmsContainer/uploadInvoice", {
            "containerBatchNo": containerBatchNo,
            "containerState": containerState,
            "invoiceUrl": res.data.data
          });
          _self.$message.success('上传成功');
          _self.getContainerCount();
          _self.getContainerList();
        }
      })
    },
    //下载文件
    async downloadFile (row) {
      let formdata = new FormData();
      formdata.append('fileUrl', row.pdfurl)
      formdata.append('fileName', row.invoiceUrl)
      var url = 'api/aliyun/oss/download';		// 请求的url + id
      var xhr = new XMLHttpRequest();
      xhr.open("POST", url, true)
      xhr.responseType = "blob";
      xhr.setRequestHeader("client_type", "DESKTOP_WEB");
      xhr.setRequestHeader("Authorization", window.sessionStorage.getItem('token'));			// 自定义请求头
      xhr.onload = function () {
        if (this.status == 200) {
          var blob = this.response;
          var fileName = row.invoiceUrl;
          if (window.navigator.msSaveOrOpenBlob) {			// IE浏览器下
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
        }
      };
      xhr.send(formdata);
    },
    handleSuccessImg (index, value) {
      // console.log(index, "-----------------")
      // console.log(value)
      // const {data:res1} =  _self.$http.post("cmsContainer/uploadInvoice",{"containerBatchNo":containerBatchNo,"invoiceUrl":res.data.data});

    },
    cannelBill (row) {
      this.$confirm("确定要取消装箱单吗？", {
        confirmButtonText: "确定",
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: "退出",
        cancelButtonClass: "form-btn btn-gray",
        type: "warning"
      }).then(async () => {
        const { data: res } = await this.$http.post(`cmsContainer/modifyContainerOrder`, {
          id: row.id,
          containerState: 5,
          containerBatchNo: row.containerBatchNo
        });
        if (res.code !== 200) {
          this.$message.error(res.message);
        } else {
          this.$message({
            type: "success",
            message: "取消成功!"
          });
          await this.getContainerCount();
          await this.getContainerList();
        }
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已退出操作"
        });
      });
    },
    async modifyContainerOrder () {    //修改装箱单
      var my = this;
      this.$refs.dialogForm.validate(async function (valid) {
        var url = 'cmsContainer/modifyContainerOrder';
        if (valid) {
          const { data: res } = await my.$http.post(url, my.ModifyContainerOrderInfo);
          if (res.code == 200) {
            my.$message({
              type: 'success',
              message: res.message
            }),
              my.ModifyPageVisible = false;
            my.getContainerCount();
            my.getContainerList();
          } else {
            my.$message({
              type: 'warning',
              message: res.message
            })
          }
        }
      })
    },
    async getContainerCount () {
      const { data: res } = await this.$http.get("cmsContainer/getContainerCount", { params: this.queryInfo });
      this.containerCount = res.data;
    },
    async getContainerList () {
      this.isLoading = true;
      const { data: res } = await this.$http.post("cmsContainer/getAllContainerList", this.queryInfo);
      this.containerList = res.data.list;
      this.total = res.data.total;
      this.isLoading = false;
    },
    async getContainerOrderList () {
      //  let formdata = new FormData()
      //  formdata.append("containerBatchNo",this.ContainerInfo);
      const { data: res } = await this.$http.post("cmsContainer/getContainerOrderList", { containerBatchNo: this.ContainerInfo });
      res.data.forEach(item => {
        this.$set(item, 'maxCount', Number(this._.add(item.canApplyCount, item.containerGoodsCount)))
      })
      this.containerOrderList = res.data;
    },
    async getDropDownList () {
      const { data: res } = await this.$http.post("cms/logisticsCompany/getDropDownList");
      this.dropDownList = res.data;
    },
    async getDropDownForLineList (line) {
      if (line) {
        const { data: res } = await this.$http.get("cms/logisticsCompany/getDropDownForLineList/" + line);
        this.dropDownListEdit = res.data;
      } else {
        this.dropDownListEdit = [];
      }

    },
    toContainerDetail (row) {
      // console.log(row);
      this.$router.push({
        name: 'boxList',
        query: {
          containerBatchNo: row.containerBatchNo
        }
      })
    },
    toEditOrder (row) {
      this.$router.push({
        name: 'orderDetail',
        query: {
          id: row.id,
          isEdit: true
        }
      })
    },
    ContainerOrderList (row, customerId, id, containerState) {
      this.curUserId = customerId
      this.curId = id
      this.curContainerState = containerState
      this.ContainerOrderListVisible = true;
      this.ContainerInfo = row;
      this.getContainerOrderList();
    },
    // 发票导出
    invoiceExport (id) {
      // this.getNowFormatDate();
      // var params = qs.stringify({
      //   token: window.sessionStorage.getItem('token'),
      //   id: id
      // })
      // window.location.href = "/api/container/exportInvoice?id=" + id


      let url = '/api/container/exportInvoice?id=' + id
      window.location.href = `${url}`

      /*this.$http({
        url: "container/exportInvoice?id=" + id,
        method: 'post',
        responseType: 'blob', // 表明返回服务器返回的数据类型
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          //接口参数
        }
      }).then((res) => {
        //创建一个隐藏的a连接，
        const link = document.createElement('a');
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none';
        //设置连接
        link.href = URL.createObjectURL(blob);
        link.download = `发票${this.currentdate}.xlsx`;
        document.body.appendChild(link);
        //模拟点击事件
        link.click();
      }).catch((err) => {
        // console.log(err);
      })*/
    },
    // 当前日期
    getNowFormatDate () {
      let date = new Date(),
        year = date.getFullYear(), //获取完整的年份(4位)
        month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
        strDate = date.getDate() // 获取当前日(1-31)
      let hour = date.getHours()
      let minute = date.getMinutes()
      let second = date.getSeconds()
      if (month >= 1 && month <= 9) month = '0' + month // 如果月份是个位数，在前面补0
      if (strDate >= 0 && strDate <= 9) strDate = '0' + strDate // 如果日是个位数，在前面补0
      this.currentdate = `${year}${month}${strDate}${hour}${minute}${second}`
    },
    ModifyContainer (row) {
      this.ModifyPageVisible = true;
      this.ContainerInfo = row;
      this.routeChange(row.route);
      // this.ModifyContainerOrderInfo.containerBatchNo = row.containerBatchNo;
      this.ModifyContainerOrderInfo = JSON.parse(JSON.stringify(row));
    },
    splitDialogClosed () {
      this.ContainerOrderListVisible = false;
    },
    ModifyPageClosed () {
      this.ModifyPageVisible = false;
    },
    splitSave () {

    },
    routeChange (val) {
      console.log(val);
      this.getDropDownForLineList(val);
      this.ModifyContainerOrderInfo.logisticsCompanyId = '';
    },
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize;
      this.getContainerCount();
      this.getContainerList();
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage;
      this.getContainerCount();
      this.getContainerList();
    },
    dateFormatYMDHMS (row, column, cellValue, index) {   //交易时间地方的时间格式化
      if (cellValue == null || cellValue == "") return "";
      let date = new Date(parseInt(cellValue) * 1000);//时间戳为10位需*1000，如果为13位的话不需乘1000。
      let Y = date.getFullYear() + '-';
      let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-';
      let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
      let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
      let m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
      let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },
    // 监听选择
    onConfirm (list) {
      console.log(list, this.containerOrderList)
      this.isVisiable = false
      list.forEach(item => {
        item.orderId = item.id

        delete item.orderStatusList
        delete item.userId
        delete item.orderIdList
        delete item.pageNum
        delete item.pageSize
        delete item.trackingNumberCn
        delete item.configCheckProjectArray
        if (!this.containerOrderList.some(citem => citem.id === item.id)) this.containerOrderList.unshift(item)
        delete item.id
      })
    },
    //删除商品
    delGooods (row) {
      this.containerOrderList.splice(this.containerOrderList.indexOf(row), 1);
    },
    // 保存商品
    onSave () {
      const params = {
        containerId: this.curId,
        containerBatchNo: this.ContainerInfo,
        listOrderJson: JSON.stringify(this.containerOrderList)
      }
      this.$http.post("container/modifyContainerOrder", params).then((res) => {
        if (res.data.code == 200) {
          this.$message.success('保存成功')
          this.getContainerList()
          this.ContainerOrderListVisible = false
        } else {
          this.$message.error(res.data.message)
        }

      }).catch(res => {
        this.$message.error(res.message)
      })
    }
  },
  watch: {
    //监听时间选择器绑定值变化
    // orderDateRangeValue(){
    //   //解决时间选择器清空后 绑定值为null问题
    //   if(!this.orderDateRangeValue){
    //     this.orderDateRangeValue = [];
    //     this.queryInfo.createTimeStart = '';
    //     this.queryInfo.createTimeEnd = '';
    //   }
    //   else{
    //     if(this.orderDateRangeValue.length>0){
    //       this.queryInfo.createTimeStart = this.orderDateRangeValue[0]/1000;
    //       this.queryInfo.createTimeEnd = this.orderDateRangeValue[1]/1000;
    //     }
    //   }
    //
    // },
    shipDateRangeValue () {
      if (!this.shipDateRangeValue) {
        this.shipDateRangeValue = [];
        this.queryInfo.sendTimeStart = '';
        this.queryInfo.sendTimeEnd = '';
      } else {
        if (this.shipDateRangeValue.length > 0) {
          this.queryInfo.sendTimeStart = this.shipDateRangeValue[0] / 1000;
          this.queryInfo.sendTimeEnd = this.shipDateRangeValue[1] / 1000;
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.el-table {
  box-flex: 1;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}

.el-pagination {
  height: 35px;
  line-height: 35px;
  text-align: center;
}

.split-col {
  padding-right: 20px;
}

.split-title {
  padding: 0 0 10px 0;
  font-size: 15px;
  font-weight: 600;
}

.link:hover,
.server-table i.el-tooltip:hover {
  cursor: pointer;
  color: #409eff;
}

.search-btn-container-status {
  text-align: left !important;
}
</style>
